module.exports = __webpack_public_path__ + "img/assistant.3accea0c.png";